import { Component, inject, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActionMenuItemComponent } from '../../../../../shared/components/action-menu-item/action-menu-item.component';
import { ActionMenuItem } from '../../../../../shared/models/action-menu-item.class';
import { ActivatedRoute, Router } from '@angular/router';
import { StormInfo, StormShift } from '../../../../../shared/models/storm.model';
import { FormattingModule } from '../../../../../shared/formatting/formatting.module';
import { ConfigurationModel } from '../../../../../shared/models/configuration.model';

export class StormStats {
  distanceDriven: number;
  distancePlowed: number;
  distanceSpreadGranular: number;
  distanceSpreadLiquid: number;
  distanceMowed: number;
  distanceSwept: number;
  materialUsedGranular: number;
  materialUsedLiquid: number;
}

@Component({
  selector: 'app-storm-panel',
  imports: [DatePipe, ActionMenuItemComponent, FormattingModule],
  templateUrl: './storm-panel.component.html',
  styleUrl: './storm-panel.component.scss',
})
export class StormPanelComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private datePipe = inject(DatePipe);

  @Input() configuration: ConfigurationModel;
  @Input() storm: StormInfo;
  @Input() shifts: StormShift[];

  shiftMenuItems: ActionMenuItem[];
  stormStats: StormStats;

  ngOnInit() {
    this.shiftMenuItems = this.shifts.map(shift => {
      return new ActionMenuItem(
        shift.id,
        'task',
        `Shift ${shift.id}`,
        this.datePipe.transform(shift.start * 1000, 'shortTime'),
        '',
        null,
        null,
        () => false,
        null,
        null,
        () => this.router.navigate([{ outlets: { shift: [shift.id] } }], { relativeTo: this.activatedRoute }),
        null,
        null,
        []
      );
    });

    this.stormStats = this.shifts.reduce(
      (totals, shift) => {
        totals.distanceDriven += shift.distanceDriven ?? 0;
        totals.distancePlowed += shift.distancePlowed ?? 0;
        totals.distanceSpreadGranular += shift.distanceSpreadGranular ?? 0;
        totals.distanceSpreadLiquid += shift.distanceSpreadLiquid ?? 0;
        totals.distanceMowed += shift.distanceMowed ?? 0;
        totals.distanceSwept += shift.distanceSwept ?? 0;
        totals.materialUsedGranular += shift.materialUsedGranular ?? 0;
        totals.materialUsedLiquid += shift.materialUsedLiquid ?? 0;
        return totals;
      },
      {
        distanceDriven: 0,
        distancePlowed: 0,
        distanceSpreadGranular: 0,
        distanceSpreadLiquid: 0,
        distanceMowed: 0,
        distanceSwept: 0,
        materialUsedGranular: 0,
        materialUsedLiquid: 0,
      } as StormStats
    );
  }
}
